// import {v1 as uuidv1} from 'uuid';

export default {
    state: {
        userCollections: [],
    },
    getters: {
        getUserCollections: state => {
            return state.userCollections;
        },
    },
    mutations: {
        setUserCollections(state, payload) {
            state.userCollections = payload;
        },
    },
    actions: {

    }
};